import React from 'react';
import { Field, Form, Formik } from 'formik';
import { Grid, MenuItem } from '@material-ui/core';
import { isNil } from 'ramda';
import { cFieldNames, validationSchema } from './schema';
import { CreateVsms } from '../../types/VsmApiResponse';
import FieldText from '../../components/Form/FieldText';
import { CreateProduction } from '../../types/ProductionApiResponse';
import FieldSelect from '../../components/Form/FieldSelect';
import { IForm } from '../../types/IForm';
import { SubmitButton } from '../../components/Form/SubmitButton';
import { useTranslation } from '../../contexts/translationContext';

interface Props extends IForm {
    onSubmit: (values: any) => void;
    data?: CreateVsms | null;
    buttonTitle: string;
    vsms?: CreateVsms[] | null;
    vsmsId: number;
}

export const ProductionForm = ({ onSubmit, data, vsms, vsmsId, userCanEdit, goBackUrl }: Props) => {
    const { t } = useTranslation();
    const initialValues: CreateProduction = {
        id: 0,
        name: '',
        description: '',
        parentVsmId: vsmsId,
    };
    return (
        <Formik
            enableReinitialize
            initialValues={isNil(data) ? initialValues : data}
            validationSchema={validationSchema(t)}
            onSubmit={(values) => {
                onSubmit(values);
            }}
        >
            {({ handleChange, handleSubmit }) => (
                <Form onSubmit={handleSubmit} onChange={handleChange}>
                    <Grid container spacing={2}>
                        <Grid item xs={12} />
                        <Grid item xs={12} md={12} lg={12}>
                            <Field
                                name={cFieldNames.name}
                                label={t('Master-data.hierarchy.detail.production.input-1')}
                                fullWidth
                                component={FieldText}
                                disabled={!userCanEdit}
                            />
                        </Grid>
                        <Grid item xs={12} md={12} lg={12}>
                            <Field
                                name={cFieldNames.description}
                                label={t('Master-data.hierarchy.detail.production.input-2')}
                                fullWidth
                                minRows={3}
                                multiline
                                component={FieldText}
                                disabled={!userCanEdit}
                            />
                        </Grid>

                        <Grid item xs={12} md={12} lg={12}>
                            <Field
                                name={cFieldNames.parentVsmId}
                                label={t('Master-data.hierarchy.detail.production.input-3')}
                                fullWidth
                                component={FieldSelect}
                                disabled
                            >
                                {vsms ? (
                                    vsms.map(({ id, name }) => (
                                        <MenuItem key={id} value={id}>
                                            {name}
                                        </MenuItem>
                                    ))
                                ) : (
                                    <MenuItem key={0} value={''} />
                                )}
                            </Field>
                        </Grid>
                        <SubmitButton goBackUrl={goBackUrl} visible={userCanEdit} />
                    </Grid>
                </Form>
            )}
        </Formik>
    );
};
